var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormCheckboxChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.3888889,4.5 L3.61111111,4.5 C1.9,4.5 0.5,5.9 0.5,7.61111111 L0.5,29.3888889 C0.5,31.1 1.9,32.5 3.61111111,32.5 L25.3888889,32.5 C27.1,32.5 28.5,31.1 28.5,29.3888889 L28.5,7.61111111 C28.5,5.9 27.1,4.5 25.3888889,4.5 L25.3888889,4.5 Z M11.3888889,26.2777778 L3.61111111,18.7991453 L5.78888889,16.7051282 L11.3888889,22.0897436 L23.2111111,10.7222222 L25.3888889,12.8162393 L11.3888889,26.2777778 L11.3888889,26.2777778 Z",
    transform: "translate(0 -4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormCheckboxChecked);
export default __webpack_public_path__ + "static/media/form-checkbox-checked.8ef5bc91ca89fd0dccacc65bffa804e5.svg";
export { ForwardRef as ReactComponent };